import { GoliathDocumentsEnumerationTypeStore } from '../../../../../enumeration-types/enumeration-type.store';

import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { LocalizationModule } from '@abp/ng.core';
import { DwTagEnumComponent } from '@digiwall/core';

interface DocTagValues {
  isDraft?: boolean;
  isClosed?: boolean;
  isBlocked?: boolean;
  blockedReason?: string;
  litigation?: boolean;
  litigationReason?: string;
  isCancelled?: boolean;
  peppolStatus?: string;
  peppolSendStatus?: string;
}

@Component({
  selector: 'document-side-panel-tags',
  templateUrl: './side-panel-tags.component.html',
  imports: [CommonModule, LocalizationModule, DwTagEnumComponent],
})
export class DocSidePanelTagsComponent {
  entity = input.required<DocTagValues>();
  protected readonly enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
}
